module.exports = __webpack_public_path__ + "media/images/redesign-images/misc/nav-image-02-41cd55bdd6f54bc00f0b89a04d5e9f85.webp";